class CartHandler {
  constructor() {
    // Bind methods
    this.addToCart = this.addToCart.bind(this);
    this.updateCartSummary = this.updateCartSummary.bind(this);
    this.addToCartFromForm = this.addToCartFromForm.bind(this);
    
    // Initialize event listeners
    this.initEventListeners();
  }

  initEventListeners() {
    // Listen for custom add to cart events
    document.addEventListener('cart:add', (event) => {
      const { variantId, quantity = 1 } = event.detail;
      this.addToCart(variantId, quantity);
    });
  }

  addToCart(variantId, quantity) {
    document.body.classList.add('cart-updating');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      this.updateCartSummary();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      document.body.classList.remove('cart-updating');
    });
  }

  addToCartFromForm(form, callback) {
    document.body.classList.add('cart-updating');

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
    .then(response => response.json())
    .then(data => {
      this.updateCartSummary();
      if (callback) callback(data);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      document.body.classList.remove('cart-updating');
    });
  }

  updateCartSummary() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.header-cart__count');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });

        fetch('/?section_id=header')
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
        
            const newCartSummary = doc.querySelector('.cart-summary');
            const currentCartSummary = document.querySelector('.cart-summary');
            
            if (newCartSummary && currentCartSummary) {
              currentCartSummary.innerHTML = newCartSummary.innerHTML;
            }
          });
      });
  }
}

window.cartHandler = new CartHandler(); 